import { useEffect } from "react";
import { useSelector } from "react-redux";
import i18n from "@/services/translations";

/**
 * Keeps i18next in sync with the persisted `setting.language` value.
 */
const LanguageSync: React.FC = () => {
  const language = useSelector((state: any) => state.setting.language);
  useEffect(() => {
    if (language && i18n.language !== language) {
      i18n.changeLanguage(language);
    }
  }, [language]);
  return null;
};

export default LanguageSync;